module.exports = __webpack_public_path__ + "dd39ed933d25bacb47aa8a2aa0c6852b.svg";